import React from 'react';
import { useAuth } from '../context/AuthContext';
import Dashboard from './Dashboard';
import Landing from './Landing';

function Home() {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Dashboard />;
  }

  return <Landing />;
}

export default Home; 